export default "__VITE_ASSET__CZOmmzwq__"